import ActiveRecord from './active_record/base'

class BalanceAdjustment extends ActiveRecord {
	static tableName = 'balanceAdjustments'
	static defaultJoins = ['users']

	revert() {
		return BalanceAdjustment.create({
			amt: -this.amt,
			date: this.date,
			initial: this.initial,
			omschrijving: this.omschrijving,
			organisation_id: this.organisation_id,
			typ: this.typ,
			user_id: this.user_id,
		})
	}
}

export default BalanceAdjustment
